import type { User } from "@auth0/auth0-react";
import { useStore } from "@/store";
import { getAuth0UserLocationId } from "@/utils/auth0";

/**
 * Resolves the location id from every place it may live, in priority order:
 * explicit URL search param → the already-resolved store instance → the Auth0
 * user's `location_id` claim. Used so every config load carries a locationId
 * whenever one is knowable, regardless of entry path (URL, kiosk/vision, Auth0).
 */
export function resolveLocationId(
	urlLocationId: string | undefined,
	user: User | null | undefined,
): string | undefined {
	return urlLocationId ?? useStore.getState().instanceInfo?.location?.id ?? getAuth0UserLocationId(user);
}
